import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaHandshake,
  FaPaintBrush,
} from "react-icons/fa";
import bannerVisual from "../Assets/Banner-5.jpg";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Carousel from "../components/Carousel";
import Clients from "../components/Clients";
import {
  ClientSection,
  FAQSection,
} from "../components/BottomSection";
import SEO from "../components/SEO";

const DISPLAY_FONT =
  '"Iowan Old Style", "Palatino Linotype", "Book Antiqua", Georgia, serif';
const BODY_FONT = '"Avenir Next", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif';

const quickLinks = [
  // { label: "Advertising", href: "/advertising" },
  { label: "Designing", href: "/designing" },
  // { label: "Digital Marketing", href: "/digital-marketing" },
  // { label: "Printing", href: "/printing" },
  { label: "Marketing Solutions", href: "/printing" },
];

const channelCards = [
  {
    icon: FaPaintBrush,
    title: "Designing",
    description:
      "Artwork, campaign assets, visual systems, and promotional creatives built for real-world rollout.",
    tags: ["Brand assets", "Social creatives", "Print design"],
    href: "/designing",
  },
  {
    icon: FaHandshake,
    title: "Marketing Solutions",
    description:
      "Ground activations, awareness bursts, and local promotion ideas that put the brand in motion.",
    tags: ["Brand promotion", "Campaign support", "On-ground marketing"],
    href: "/printing",
  },
  // {
  //   icon: FaBroadcastTower,
  //   title: "Radio Advertising",
  //   description:
  //     "Reach commuters, households, and local audiences with sharp scripting and smart slot planning.",
  //   tags: ["FM stations", "RJ plugs", "Jingles"],
  //   href: "/radio-advertising",
  // },
  // {
  //   icon: FaBusAlt,
  //   title: "Transit Media",
  //   description:
  //     "Own high-frequency routes with cab wraps, bus branding, metro visibility, and airport placements.",
  //   tags: ["Bus wraps", "Metro", "Airport media"],
  //   href: "/transit-advertising",
  // },
  // {
  //   icon: FaNewspaper,
  //   title: "Newspaper Advertising",
  //   description:
  //     "Build trust fast with regional editions, inserts, classifieds, and premium print positions.",
  //   tags: ["Regional press", "Classifieds", "Inserts"],
  //   href: "/newspaper-advertising",
  // },
  // {
  //   icon: FaFilm,
  //   title: "Cinema Advertising",
  //   description:
  //     "Create high-attention brand recall with on-screen films, theatre spots, and captive-audience storytelling.",
  //   tags: ["Theatre spots", "Multiplex", "On-screen ads"],
  //   href: "/cinema-advertising",
  // },
  // {
  //   icon: FaUsers,
  //   title: "Influencer Marketing",
  //   description:
  //     "Pair your brand with credible creators and regional voices who already have audience trust.",
  //   tags: ["Instagram", "YouTube", "Creator campaigns"],
  //   href: "/influencer-marketing",
  // },
  // {
  //   icon: FaBullhorn,
  //   title: "Digital Advertising",
  //   description:
  //     "Run measurable campaigns across performance channels with messaging tuned for modern buying journeys.",
  //   tags: ["Meta", "Google", "Lead generation"],
  //   href: "/digital-advertising",
  // },
];

const capabilitySets = [
  {
    title: "Designing",
    description:
      "Artwork, campaign assets, visual systems, and promotional creatives built for real-world rollout.",
    icon: FaPaintBrush,
    href: "/designing",
  },
  {
    title: "Marketing Solutions",
    description:
      "Ground activations, awareness bursts, and local promotion ideas that put the brand in motion.",
    icon: FaHandshake,
    href: "/printing",
  },
  // {
  //   title: "Brand Endorsements",
  //   description:
  //     "Celebrity and personality-led campaigns for brands that need scale, trust, and memorability.",
  //   icon: FaStar,
  //   href: "/brand-endorsement",
  // },
  // {
  //   title: "Strategic Media Planning",
  //   description:
  //     "Audience-aware plans that balance budgets, timing, placements, and expected outcome.",
  //   icon: FaChartLine,
  //   href: "/advertising",
  // },
];

const workflowSteps = [
  {
    title: "Discover",
    body: "We align the campaign with your audience, city, offer, and budget realities.",
    stage: "01",
  },
  {
    title: "Shape",
    body: "The media mix, messaging, and creative direction are assembled into one clear rollout plan.",
    stage: "02",
  },
  {
    title: "Launch",
    body: "Production, bookings, approvals, and go-live execution are coordinated without handoff chaos.",
    stage: "03",
  },
  {
    title: "Improve",
    body: "Performance signals guide adjustments so the next wave gets sharper, not noisier.",
    stage: "04",
  },
];

function HomePage() {
  return (
    <>
      <SEO
        title="Home"
        description="Indorinama - Premier advertising, designing, and marketing solutions in India. Get professional graphic design, marketing promotions, printing services, corporate gifting, and digital marketing solutions."
        keywords="advertising agency, graphic design, marketing promotion, printing services, digital marketing, corporate gifting, brand promotion, India, creative agency"
        url="https://indorinama.com/"
        type="website"
      />
      <div
      className="min-h-screen bg-[#f5efe8] text-slate-900 selection:bg-brand-red selection:text-white"
      style={{ fontFamily: BODY_FONT }}
    >
      <Navbar />

      <main className="overflow-hidden">
        <section className="relative isolate border-b border-black/5 bg-[#f5efe8] pt-8 sm:pt-12">
          <div className="absolute inset-x-0 top-0 h-[32rem] bg-[radial-gradient(circle_at_top_left,_rgba(188,21,53,0.18),_transparent_48%)]" />
          <div className="absolute right-0 top-16 h-80 w-80 rounded-full bg-[radial-gradient(circle,_rgba(15,23,42,0.12),_transparent_70%)] blur-3xl" />

          <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-8 sm:px-6 lg:px-8 lg:pb-24 lg:pt-14">
            <div className="grid gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:items-center">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <h1
                  className="max-w-4xl text-[2.85rem] leading-[0.92] text-[#111827] sm:text-[4.2rem] lg:text-[5.4rem]"
                  style={{ fontFamily: DISPLAY_FONT }}
                >
                  Give your brand a stronger public presence.
                </h1>

                <p className="mt-6 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
                  Indorinama brings advertising, creative execution, creator campaigns,
                  digital promotion, and production into one sharper operating system.
                  The homepage now points people to real service destinations instead of dead ends.
                </p>

                <div className="mt-8 flex flex-wrap gap-2 sm:gap-3">
                  <Link
                    to="/printing"
                    className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#15110e] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-white no-underline shadow-[0_18px_40px_rgba(21,17,14,0.18)] transition-transform duration-200 hover:-translate-y-0.5 hover:text-white sm:px-5 sm:text-xs"
                  >
                    Start with promotion
                    <FaArrowRight className="transition-transform duration-200 group-hover:translate-x-1" />
                  </Link>
                  <Link
                    to="/designing"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-[#15110e]/10 bg-white/80 px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#15110e] no-underline backdrop-blur transition-colors duration-200 hover:border-brand-red/25 hover:text-brand-red sm:px-5 sm:text-xs"
                  >
                    Explore creative services
                  </Link>
                </div>

                <div className="mt-8 flex flex-wrap gap-3">
                  {quickLinks.map((item) => (
                    <Link
                      key={item.href}
                      to={item.href}
                      className="rounded-full border border-black/5 bg-white/75 px-4 py-2 text-sm font-medium text-slate-700 no-underline transition-all duration-200 hover:-translate-y-0.5 hover:border-brand-red/20 hover:text-brand-red"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
                className="relative"
              >
                <div className="absolute -left-4 top-12 hidden h-28 w-28 rounded-full border border-brand-red/15 bg-white/50 blur-sm sm:block" />
                <div className="absolute -right-4 bottom-10 hidden h-36 w-36 rounded-full bg-brand-red/10 blur-2xl sm:block" />

                <div className="relative overflow-hidden rounded-[2rem] border border-white/70 bg-[#111827] p-3 shadow-[0_28px_80px_rgba(15,23,42,0.18)] sm:p-4">
                  <div className="relative overflow-hidden rounded-[1.6rem]">
                    <img
                      src={bannerVisual}
                      alt="Indorinama campaign showcase"
                      className="h-[22rem] w-full object-cover sm:h-[28rem] lg:h-[34rem]"
                    />
                    <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(15,23,42,0.14),rgba(15,23,42,0.72))]" />

                    <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7">
                      <div className="max-w-md rounded-[1.6rem] border border-white/10 bg-black/35 p-5 text-white backdrop-blur-md">
                        <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-white/70">
                          Homepage direction
                        </p>
                        <h2
                          className="mt-3 text-3xl leading-tight text-white sm:text-[2.3rem]"
                          style={{ fontFamily: DISPLAY_FONT }}
                        >
                          Less placeholder. More momentum.
                        </h2>
                        <p className="mt-3 text-sm leading-6 text-white/75 sm:text-base">
                          Service routes, campaign highlights, and content sections now work like a real entry point instead of a decorative landing screen.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        <section id="services" className="bg-white py-20 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <span className="text-xs font-semibold uppercase tracking-[0.32em] text-brand-red">
                Available Services
              </span>
              <h2
                className="mt-4 text-4xl text-[#111827] sm:text-5xl"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                Start with the service lines that are live now.
              </h2>
              <p className="mt-6 text-base leading-7 text-slate-600 sm:text-lg">
                This section only surfaces active destinations so visitors and payment reviewers do not hit incomplete service flows.
              </p>
            </div>

            <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
              {channelCards.map((card, index) => (
                <Link key={card.href} to={card.href} className="group block no-underline">
                  <motion.article
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.45, delay: index * 0.05 }}
                    whileHover={{ y: -6 }}
                    className="flex h-full flex-col rounded-[2rem] border border-slate-900/5 bg-[#fcfaf7] p-7 shadow-[0_18px_40px_rgba(15,23,42,0.05)] transition-shadow duration-200 group-hover:shadow-[0_26px_55px_rgba(188,21,53,0.12)]"
                  >
                    <div className="flex items-center justify-between gap-4">
                      <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-red/10 text-2xl text-brand-red">
                        <card.icon />
                      </div>
                      <span className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">
                        Explore
                      </span>
                    </div>

                    <h3
                      className="mt-6 text-[1.9rem] leading-tight text-[#111827]"
                      style={{ fontFamily: DISPLAY_FONT }}
                    >
                      {card.title}
                    </h3>
                    <p className="mt-4 flex-1 text-sm leading-7 text-slate-600 sm:text-base">
                      {card.description}
                    </p>

                    <div className="mt-6 flex flex-wrap gap-2">
                      {card.tags.map((tag) => (
                        <span
                          key={tag}
                          className="rounded-full border border-black/5 bg-white px-3 py-1 text-xs font-medium uppercase tracking-[0.14em] text-slate-500"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>

                    <div className="mt-7 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-brand-red">
                      Open service page
                      <FaArrowRight className="transition-transform duration-200 group-hover:translate-x-1" />
                    </div>
                  </motion.article>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-[#16110e] py-20 text-white sm:py-24">
          <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[0.92fr_1.08fr] lg:items-start lg:px-8">
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-semibold uppercase tracking-[0.32em] text-[#ff8ca0]">
                Active Catalogue
              </span>
              <h2
                className="mt-4 text-4xl sm:text-5xl"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                Keep the public catalogue focused.
              </h2>
              <p className="mt-6 max-w-xl text-base leading-7 text-white/70 sm:text-lg">
                The homepage now highlights only the service categories that are ready for public traffic and checkout-related review.
              </p>
              <div className="mt-8">
                <Link
                  to="/designing"
                  className="inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.06] px-6 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-white no-underline transition-colors duration-200 hover:border-[#ff8ca0]/40 hover:text-[#ffb2c0]"
                >
                  Browse active services
                  <FaArrowRight />
                </Link>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2">
              {capabilitySets.map((service, index) => (
                <Link key={service.href} to={service.href} className="group block no-underline">
                  <motion.article
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.4, delay: index * 0.08 }}
                    whileHover={{ y: -6 }}
                    className="h-full rounded-[1.9rem] border border-white/10 bg-white/5 p-7 backdrop-blur-sm transition-colors duration-200 group-hover:border-[#ff8ca0]/30 group-hover:bg-white/[0.08]"
                  >
                    <div className="text-3xl text-[#ff8ca0]">
                      <service.icon />
                    </div>
                    <h3
                      className="mt-6 text-3xl leading-tight text-white"
                      style={{ fontFamily: DISPLAY_FONT }}
                    >
                      {service.title}
                    </h3>
                    <p className="mt-4 text-sm leading-7 text-white/70 sm:text-base">
                      {service.description}
                    </p>
                    <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-[#ffb2c0]">
                      Go to service
                      <FaArrowRight className="transition-transform duration-200 group-hover:translate-x-1" />
                    </div>
                  </motion.article>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-[#f5efe8] py-20 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <span className="text-xs font-semibold uppercase tracking-[0.32em] text-brand-red">
                Process
              </span>
              <h2
                className="mt-4 text-4xl text-[#111827] sm:text-5xl"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                A cleaner journey from brief to rollout.
              </h2>
            </div>

            <div className="relative mt-14 grid gap-5 lg:grid-cols-4">
              <div className="absolute left-0 right-0 top-11 hidden border-t border-dashed border-brand-red/20 lg:block" />
              {workflowSteps.map((step, index) => (
                <motion.article
                  key={step.title}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="relative rounded-[1.7rem] border border-black/5 bg-white p-6 shadow-[0_18px_35px_rgba(15,23,42,0.05)]"
                >
                  <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-brand-red text-xl font-semibold text-white shadow-[0_18px_30px_rgba(188,21,53,0.25)]">
                    {step.stage}
                  </div>
                  <h3
                    className="text-[2rem] leading-none text-[#111827]"
                    style={{ fontFamily: DISPLAY_FONT }}
                  >
                    {step.title}
                  </h3>
                  <p className="mt-4 text-sm leading-7 text-slate-600 sm:text-base">
                    {step.body}
                  </p>
                </motion.article>
              ))}
            </div>
          </div>
        </section>

        <section id="portfolio" className="bg-white py-20 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
              <span className="text-xs font-semibold uppercase tracking-[0.32em] text-brand-red">
                Showcase
              </span>
              <h2
                className="mt-4 text-4xl text-[#111827] sm:text-5xl"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                Recent campaign moments.
              </h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                This section now points to an existing service catalogue instead of the broken `/work` route.
              </p>
            </div>

            <div className="mt-10 overflow-hidden rounded-[2rem] border border-black/5 shadow-[0_24px_60px_rgba(15,23,42,0.08)]">
              <Carousel />
            </div>
          </div>
        </section>

        <section className="border-t border-black/5 bg-white py-20 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              <span className="text-xs font-semibold uppercase tracking-[0.32em] text-brand-red">
                Social Proof
              </span>
              <h2
                className="mt-4 text-4xl text-[#111827] sm:text-5xl"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                Brands already trust the process.
              </h2>
            </div>

            <div className="mt-12">
              <Clients category="home" />
            </div>

            <div className="mt-16 rounded-[2rem] bg-[#16110e] px-6 py-10 text-white sm:px-10">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
                <div className="max-w-2xl">
                  <p className="text-xs font-semibold uppercase tracking-[0.32em] text-[#ff8ca0]">
                    Ready to move
                  </p>
                  <h2
                    className="mt-3 text-3xl sm:text-4xl"
                    style={{ fontFamily: DISPLAY_FONT }}
                  >
                    Pick a route and start the conversation.
                  </h2>
                  <p className="mt-4 text-sm leading-7 text-white/70 sm:text-base">
                    Use the homepage as a real launchpad into advertising, creative, digital, or outreach instead of sending users into placeholders.
                  </p>
                </div>

                <div className="flex flex-wrap gap-2 sm:gap-3">
                  <Link
                    to="/printing"
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-white no-underline transition-transform duration-200 hover:-translate-y-0.5 hover:text-white sm:px-5 sm:text-xs"
                  >
                    Open promotions
                    <FaArrowRight />
                  </Link>
                  <a
                    href="mailto:help@indorinama.in"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-white no-underline transition-colors duration-200 hover:border-white/30 hover:text-[#ffb2c0] sm:px-5 sm:text-xs"
                  >
                    Email the team
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQSection />
        <ClientSection />
      </main>

      <Footer />
      </div>
    </>
  );
}

export default HomePage;
